import { render, staticRenderFns } from "./ImageManage.vue?vue&type=template&id=585ef2e2"
import script from "./ImageManage.vue?vue&type=script&lang=ts"
export * from "./ImageManage.vue?vue&type=script&lang=ts"
import style0 from "./ImageManage.vue?vue&type=style&index=0&id=585ef2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports